// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pv-8";
export var editMode = "_pv-3";
export var headerRow = "_pv-a";
export var headerTitle = "_pv-b";
export var product = "_pv-1";
export var productDetails = "_pv-5";
export var productDivider = "_pv-7";
export var productImage = "_pv-2";
export var productInfo = "_pv-4";
export var productTitle = "_pv-6";
export var strikethrough = "_pv-9";
export var upsellProductsCard = "_pv-0";